<template>
    <div>
        <transition name="fade">
            <div class="modal-shadow" v-show="open"></div>
        </transition>
        <queue-receiver class="modals" ns="modal" transition="from-top" v-show="open">
            <template #item="{index, data, listeners, close}">
                <component :is="data.component"
                           v-bind="data.props"
                           :style="style"
                           v-show="index === count-1"
                           v-on="listeners"
                           @close="close"
                />
            </template>
        </queue-receiver>
    </div>
</template>

<script>
    export default {
        props: {
            responsive: {type: Boolean, default: false},
            width: {type: String, default: '600px'},
        },

        computed: {
            count() {
                return this.$queue.getCount('modal');
            },
            open() {
                return this.count > 0;
            },

            style() {
                let style = {};
                if (this.responsive) {
                    style.maxWidth = this.width;
                } else {
                    style.width = this.width;
                }
                return style;
            },
        },

        watch: {
            open() {
                document.body.classList.toggle('modal-open', this.open);
            },
        },
    };
</script>
